export const DEFAULT_STORAGE_KEY = "alchemy-account-state";
//# sourceMappingURL=types.js.map